// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__VDc_p","errors":"Errors_errors__2QDm_"};